<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-flex(xs12)
        v-toolbar(flat dense color="pink darken-1")
          v-icon.white--text fa-hourglass-half
          v-toolbar-title.white--text {{$t('order.estimated')}}
    v-layout(row wrap)
      v-flex(xs12 sm6 md4)
        v-text-field.ma-0(
          placeholder="検索: 見積番号/営業担当/業務担当/顧客担当"
          hide-details
          color="info"
          type="text"
          v-model="keyword"
          autocapitalize="off"
          prepend-icon="search"
        )

    transition-group(name="flip-list" tag="div" class="layout row wrap")
      div.flex.xs12.sm6.md4.lg3.flip-list-item(v-for="order in filteredList" :key="order.token")
        list-item(
          :token="order.token"
          :requested="false"
          :estimated="true"
          :settled="false"
          :arranged="false"
          :completed="false"
          :search="{ enabled: false, color: 'pink darken-1', status: $t('order.estimated')}"
        )
</template>

<script>
import ListItem from '../Components/ListItem'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    ListItem
  },
  data () {
    return {
      keyword: ''
    }
  },
  created () {
    this.clearList()
    this.$ajax.get('order/requested').then(response => {
      const requested = response.data.list
      this.$ajax.get('order/estimated').then(response => {
        const merged = requested.concat(response.data.list)
        this.setList(merged)
      })
    })
  },
  beforeDestroy () {
    this.clearList()
  },
  computed: {
    ...mapGetters('app/list', ['list']),
    filteredList () {
      const search = this.keyword || ''
      const searches = search.split(' ').map(v => new RegExp(v))
      return this.list.filter(order => {
        const searchText = [
          ...new Set([order.id + '', (order.tags || '').split(' ')])
        ]
        return searches.map(v => v.test(searchText)).every(v => v)
      })
    }
  },
  methods: {
    ...mapActions('app/list', ['clearList', 'setList'])
  }
}
</script>

<style scoped lang="stylus">
.flip-list-item {
  transition: transform 0.5s;
}

.flip-list-enter, .flip-list-leave-to {
  opacity: 0;
}

.flip-list-leave-active {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/app/pages/List/Estimated/index.vue